import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { ErrorHandler } from '@angular/core';
import { environment } from 'src/environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? (environment.test ? 'test' : 'prod') : 'dev'
});

@Injectable({
  providedIn: 'root'
})
export class ErrorMonitoringService implements ErrorHandler {

  method = '';

  constructor() {}

  // envia el error a Sentry
  handleError(error) {
    if (!environment.production) {
      console.error('ERROR', error);
    }
    if (environment.production || environment.test) {
      const eventId = Sentry.captureException(error.originalError || error);
      if (environment.test) {
        Sentry.showReportDialog(
          { eventId,
            title: 'Ups! Ha ocurrido un error',
            subtitle: 'Ayúdanos a solucionarlo, indicanos que pasó a continuación',
            subtitle2: ''
          }
        );
      }
    }
  }

  sendError(error: any, method: string) {
    if (environment.production || environment.test) {
      Sentry.withScope(scope => {
        scope.setTag('method', method);
        Sentry.captureException(error.originalError || error);
      });
    }
  }

  // define el usuario al que pertenece el error
  setUserContext(user: any) {
    Sentry.configureScope((scope) => {
      scope.setUser({
        email: user ? user.email : ''
      });
    });
  }

}
